import axios from 'axios';

export default class GeolocalizacaoService {

    getLongLat(lat, long) {
        const param = '?latlng='+lat+','+long+'&'+process.env.VUE_APP_KEY_GEOLC;
        let instance = axios.create();
        delete instance.defaults.headers.common['Authorization'];
        delete instance.defaults.headers.common['X-IKPonto-Request'];
        return instance({
            method: 'GET',
            url: process.env.VUE_APP_GEOLC+ param
        });
    }

}